<script>
/**
 * Extends VTooltip with interactivity
 * @see https://material-ui.com/components/tooltips/#interactive
 */

import { VTooltip } from 'vuetify/lib';

export default {
  extends: VTooltip,
  props: {
    interactive: {
      type: Boolean,
      default: false,
    },
    opacity: {
      type: Number,
      default: 0.9,
    },
    closeDelay: {
      type: [Number, String],
      default: 50,
    },
  },
  computed: {
    // I'm not 100% sure in this, but it works
    calculatedLeft() {
      const originalValue = VTooltip.options.computed.calculatedLeft.call(this);
      if (!this.interactive) return originalValue;
      const { left, right } = this;
      let value = parseInt(originalValue);
      if (left || right) {
        value += right ? -10 : 10;
      }
      return `${value}px`;
    },
    calculatedTop() {
      const originalValue = VTooltip.options.computed.calculatedTop.call(this);
      if (!this.interactive) return originalValue;
      const { top, bottom } = this;
      let value = parseInt(originalValue);
      if (top || bottom) {
        value += bottom ? -10 : 10;
      }
      return `${value}px`;
    },
    styles() {
      const originalValue = VTooltip.options.computed.styles.call(this);
      if(this.isActive) originalValue.opacity = this.opacity;
      if (!this.interactive) return originalValue;
      const {
        top, bottom, left, right,
      } = this;
      let paddingDirection;
      if (bottom) paddingDirection = 'top';
      else if (top) paddingDirection = 'bottom';
      else if (right) paddingDirection = 'left';
      else if (left) paddingDirection = 'right';
      return {
        ...originalValue,
        [`padding-${paddingDirection}`]: `${10}px`,
      };
    },
  },
  methods: {
    onTooltipMouseenter(e) {
      if (this.interactive) {
        this.clearDelay();
        this.isActive = true;
      }
      this.$emit('tooltip:mouseenter', e);
    },
    onTooltipMouseleave(e) {
      if (this.interactive) {
        this.clearDelay();
        this.runDelay('close');
      }
      this.$emit('tooltip:mouseleave', e);
    },
    genContent() {
      const content = this.$createElement('div', this.setBackgroundColor(this.color, {
        style: this.contentStyles,
        staticClass: 'v-tooltip__content',
        class: {
          [this.contentClass]: true,
          menuable__content__active: this.isActive,
        },
      }), this.getContentSlot());
      return this.$createElement('div', {
        style: this.styles,
        attrs: this.getScopeIdAttrs(),
        class: {
          'v-tooltip__wrapper': true,
          'v-tooltip__wrapper--fixed': this.activatorFixed,
        },
        directives: [{
          name: 'show',
          value: this.isContentActive,
        }],
        on: {
          mouseenter: this.onTooltipMouseenter,
          mouseleave: this.onTooltipMouseleave,
        },
        ref: 'content',
      }, [content]);
    },
    genActivatorListeners() {
      const listeners = VTooltip.options.methods.genActivatorListeners.call(this);

      if (this.interactive) {
        if (listeners.mouseenter) {
          listeners.mouseenter = (e) => {
            this.getActivator(e);
            this.clearDelay();
            if (!this.isActive) {
              this.runDelay('open');
            }
          };
        }
      }

      return listeners;
    },
  },

};
</script>

<style lang="scss">
.v-tooltip__wrapper {
  position: absolute;
  &--fixed {
    position: fixed;
  }
  .v-tooltip__content {
    position: static;
  }
}
</style>